import { LinearIcon } from "#components/ui/LinearIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const linearManifest: IntegrationManifest = {
    key: "linear",
    displayName: "Linear",
    nameKey: "channels.linear",
    descriptionKey: "linearDescription",
    trayDescriptionKey: "composerTrayDescriptions.linear",
    cardDescriptionKey: "connectIntegration.descriptions.linear",
    connectedContentKeys: ["linearIssues"],
    brandColor: "#5E6AD2",
    iconUrl: IconAssets.Linear,
    iconUrlAlt: IconAssets.LinearAlt,
    glyph: LinearIcon,
    channelType: "UserLinearMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
